import React from "react";
import {
  FilterValues,
  ListFilterState,
  UseListFilterProps,
  UseListFilterReturn,
} from "./types";
import { createFilterControl } from "./create-filter-control";
import { useSubscribe } from "./use-subscribe";
import getProxyFilterState from "./get-proxy-filter-state";

export function useListFilter<
  TFilterValues extends FilterValues = FilterValues
>(
  props: UseListFilterProps<TFilterValues>
): UseListFilterReturn<TFilterValues> {
  const _filterControl = React.useRef<
    UseListFilterReturn<TFilterValues> | undefined
  >();

  const [filterState, updateFilterState] = React.useState<
    ListFilterState<TFilterValues>
  >({
    defaultValues: props.defaultValues,
    activeFiltersCount: 0,
  });

  if (!_filterControl.current) {
    _filterControl.current = {
      ...createFilterControl(props),
      filterState,
    };
  }

  const control = _filterControl.current.control;

  useSubscribe({
    subject: control._subjects.state,
    next: (
      value: Partial<ListFilterState<TFilterValues>> & { name?: string }
    ) => {
      control._updateFilterState(value);
      updateFilterState({ ...control._filterState });
    },
  });

  React.useEffect(() => {
    control._updateActiveFiltersCount();
  }, []);

  _filterControl.current.filterState = getProxyFilterState(
    filterState,
    control
  );

  return _filterControl.current;
}
